import dayjs from 'dayjs'

export type StayPeriods = {
  roomCheckinDate: string
  roomCheckoutDate: string
}[]

export const isAllSameStayPeriod = (StayPeriods: StayPeriods) => {
  // 最初の要素を基準にする
  const first = StayPeriods[0]

  return StayPeriods.every(period => {
    return (
      dayjs(period.roomCheckinDate).isSame(dayjs(first.roomCheckinDate)) &&
      dayjs(period.roomCheckoutDate).isSame(dayjs(first.roomCheckoutDate))
    )
  })
}
